import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      stroke: "#495465",
      "stroke-miterlimit": "10"
    }, [
      _createElementVNode("path", { d: "M13 5.629v3.085c0 2.057-.6 2.572-3 2.572H4c-2.4 0-3-.515-3-2.572V3.571C1 1.514 1.6 1 4 1h.9c.9 0 1.098.226 1.44.617l.9 1.029c.228.257.36.411.96.411H10c2.4 0 3 .514 3 2.572Z" }),
      _createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M4.9 1h5.4q1.8 0 1.8 1.543v.71M8.5 7.686h-3"
      })
    ], -1)
  ])))
}
export default { render: render }